<script>
import OptionCard from '@/components/inputs/OptionCardDecomposed.vue'
import { mapGetters } from "vuex";
export default {
    components: {
      OptionCard
    },

    data() {
      return {
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      }
    },

    computed: {
      ...mapGetters({
        config: 'getConfig', 
        funderingTypes: 'getFunderingTypesPublic',
      }),
    },

    methods: {
      setFoundation (fundering) {
        this.$store.dispatch('updateFoundationType', fundering)
        this.$store.dispatch('updateFoundation', fundering.poerenEnabled)
      }
    }
  }
</script>
<template>
  <!-- <section 
    v-if="basis.length > 1"
    id="mainsection"
  >
    <OptionCard 
      v-for="(optie, index) in basis" 
      :key="index"
      :data="optie" 
      :selected="config.fundering"
      :has-automargin="false"
      @select="updateBasisOption(optie)"
    />
  </section>
  <section 
    v-else
    id="mainsectionsolo"
  >
    <OptionCard 
      v-for="(optie, index) in basis" 
      :key="index"
      :data="optie" 
      :selected="config.fundering"
      :has-automargin="true"
      :has-widthlimit="false"
      @select="updateBasisOption(optie)"
    />
  </section> -->
  <div class="container">
    <OptionCard 
      v-for="(fundering, index) in funderingTypes" 
      :key="index"
      :image="`${previewsServer}/textures/${fundering.uiImage?.url}`"
      :label="fundering.label"
      :description="fundering.description"
      :infobox="fundering.infobox"
      :selected="config.funderingType === fundering.id"
      :has-automargin="true"
      :has-widthlimit="false"
      @select="setFoundation(fundering)"
    />
  </div>
</template>
<style lang="scss" scoped>
#mainsection {
  // margin: 1rem;
  // margin: 1rem 1rem 1rem 3px;
  display: grid;
  padding: 25px 0px;
  gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-auto-rows: minmax(min-content, max-content);
  // width: 100%;
}
#mainsectionsolo {
  padding: 25px 0px;
}

.container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>